<template>
  <el-row class="cs-contentContainer cs-wechatRe-content" v-loading="isLoading">
    <el-col>
      <el-row class="cs-wechatRe-item">
        <el-col>
          <span>速成学员账号:</span>
          <span>{{studentName}}</span>
        </el-col>
      </el-row>
      <div v-if="action == 'validation'">
        <el-row class="cs-wechatRe-item cs-wechatRe-success" v-if="isSuccess">
          <el-col>
            <el-row class="cs-wechatRe-success-item">
              <el-col>
                <img src="../../assets/success.png" />
              </el-col>
            </el-row>
            <el-row class="cs-wechatRe-success-item">
              <el-col>
                <span>确认成功！</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div v-if="action == 'binding'">
        <el-row class="cs-wechatRe-item">
          <el-col>
            <span>微信账号:</span>
            <span>{{wechatUserName}}</span>
          </el-col>
        </el-row>
        <el-row class="cs-wechatRe-item" v-if="!isSuccess">
          <el-col>
            <el-button :disabled="isBinding" type="success" @click="onClickBind">确认绑定</el-button>
          </el-col>
        </el-row>
        <el-row class="cs-wechatRe-item cs-wechatRe-success" v-if="isSuccess">
          <el-col>
            <el-row class="cs-wechatRe-success-item">
              <el-col>
                <img src="../../assets/success.png" />
              </el-col>
            </el-row>
            <el-row class="cs-wechatRe-success-item">
              <el-col>
                <span>绑定成功！</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>
</template>

<style lang="scss" scoped>
.cs-wechatRe-content {
  margin: auto;
  display: table;
  .cs-wechatRe-item {
    margin-top: 10px;
    line-height: 20px;
    font-size: 16px;
  }
  .cs-wechatRe-success {
    text-align: center;
    margin-top: 20px;
    img {
      height: 85px;
      margin-bottom: 10px;
    }
  }
}
</style>

<script>
import {
  getWechatUserInfo,
  bindWechat,
  validateWechatUser,
} from "../../service/user.service";
import { getStore, setStore } from "../../config/mUtils";

export default {
  props: {},
  data() {
    return {
      studentName: "",
      wechatUserName: "",
      unionid: "",
      isBinding: false,
      isSuccess: false,
      isLoading: false,
      action: "", //binding:绑定微信,validation:验证微信
    };
  },
  created() {
    let data = this.$route.query.data;
    if (!!data) {
      let result = JSON.parse(data); //格式: {success: false, code:"", action:"", message: ""};
      this.action = result.action;
      if (result.success) {
        switch (this.action) {
          case "binding": {
            this.getUseInfo(result);
            break;
          }
          case "validation": {
            this.validateUser(result);
            break;
          }
        }
      } else {
        this.$message.error(result.message);
      }
    }
    this.studentName = getStore("user_name");
  },
  methods: {
    validateUser(data) {
      this.isLoading = true;
      validateWechatUser(data.code)
        .then((result) => {
          if (!!result && result.success) {
            this.isSuccess = true;
            this.sendMsg(true, "");
          } else {
            this.sendMsg(false, result.message);
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getUseInfo(data) {
      this.isLoading = true;
      getWechatUserInfo(data.code)
        .then((result) => {
          if (!!result && result.success) {
            this.wechatUserName = result.data.nickname;
            this.unionid = result.data.unionid;
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onClickBind() {
      this.isBinding = true;
      bindWechat(this.unionid, this.wechatUserName)
        .then((result) => {
          if (!!result && result.success) {
            this.isSuccess = true;
            setStore("user_student_hasWechat", 1);
            this.sendMsg(true, "");
          } 
          this.isBinding = false;
        })
        .catch(() => {
          this.isBinding = false;
        });
    },
    sendMsg(success, message) {
      window.parent.postMessage(
        {
          cmd: this.action,
          params: {
            success: success,
            message: message,
          },
        },
        "*"
      );
    },
  },
  watch: {},
};
</script>
 



// WEBPACK FOOTER //
// src/page/wechat/wechatResponse.vue